/* eslint-disable import/extensions */
import 'vanilla-ripplejs'
import './frontend.scss'
import common from './routes/common'
import home from './routes/home'
import postTypeArchiveProduct from './routes/product'
import singleProduct from './routes/singleProduct'
import postTypeArchiveCertificate from './routes/certificate'
import contactUs from './routes/contact'
import aboutUs from './routes/about'
import inquiry from './routes/inquiry'

import Router from './util/Router'
// import 'https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js'
// require('https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js')
/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  common,
  home,
  postTypeArchiveProduct,
  singleProduct,
  postTypeArchiveCertificate,
  contactUs,
  aboutUs,
  inquiry,
})

window.addEventListener('DOMContentLoaded', () => {
  routes.loadEvents()
})
